// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */
import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class AuthorizationTokenOutput {
  readonly success: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.success = data.success === undefined ? false : data.success;
  }

  static zero(): AuthorizationTokenOutput {
    const zeroValues: ExcludeMethodsDeep<AuthorizationTokenOutput> = {
      success: false,
    };
    return new AuthorizationTokenOutput(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AuthorizationTokenOutputWireFormat = {
  success: boolean;
};

type NewAuthorizationTokenOutputProps = PartialDeep<
  AuthorizationTokenOutput,
  { recurseIntoArrays: true }
>;
export const NewAuthorizationTokenOutput: (
  props: NewAuthorizationTokenOutputProps,
) => AuthorizationTokenOutput = (props) => new AuthorizationTokenOutput(props);

export const NewAuthorizationTokenOutputFromWireFormat = (
  props: PartialDeep<AuthorizationTokenOutputWireFormat, { recurseIntoArrays: true }>,
): AuthorizationTokenOutput => new AuthorizationTokenOutput(props);
